import { OilIntakeLogModel } from "../../models/oilProduction-model";
import * as XLSX from "xlsx";

export const oilProcessExport = (oilProcessData: OilIntakeLogModel[]) => {
  if (!oilProcessData || oilProcessData.length === 0) {

    console.warn("No data to export");
    console.log("Exporting data:", oilProcessData);
    return;
  }

  const formatOilIntakeLogNo = (id?: number | null) => {
  if (!id) return "";
  return `OIL${id.toString().padStart(8, "0")}`;
  };


  // Prepare data for Excel
  const formattedData = oilProcessData.map((item) => ({

   "Oil Intake Log #": formatOilIntakeLogNo(item.id),
    "Production Date": item.submittedDate
      ? new Date(item.submittedDate).toLocaleDateString()
      : "",   
       "Gaana Name/ಗಾಣದ ಕ್ರಮ ಸಂಖ್ಯೆ": item.gaanaName ?? "",
      "Batch" : item.batch?? " ",
          "Start Time": item.startTime ?? "",
          "End Time": item.endTime ?? "",
   
     "Manufacturing Unit": item.posName ?? "",
    "OilSeed Name/ಎಣ್ಣೆಕಾಳು ಬೀಜದ ಹೆಸರು ": item.oilSeedName ?? "",
    "Oilseed Weight (KG)/ಎಣ್ಣೆ ಕಾಳು / ಬೀಜದ ತೂಕ (ಕೆಜಿಗಳಲ್ಲಿ)": item.oilSeedWeight ?? "",
    "Moisture Content (%)/ತೇವಾಂಶ ": item.moistureContent ?? "",
    "Empty Container Weight (KG)/ಖಾಲಿ ಪಾತ್ರೆ ತೂಕ (ಕೆಜಿಗಳಲ್ಲಿ)": item.emptyContainerWeightKG ?? "",
    "Total OilWeight With ContainerKG/ಪಾತ್ರೆ ಮತ್ತು ಎಣ್ಣೆ - ಒಟ್ಟು ತೂಕ (ಕೆಜಿಗಳಲ್ಲಿ)":
      item.dailyOutputs && item.dailyOutputs.length > 0
        ? item.dailyOutputs[0].totalOilWeightWithContainerKG ?? ""
        : "",
    "Cake Weight (kg)": item.cakeOutputs && item.cakeOutputs.length > 0
      ? item.cakeOutputs[0].cakeWeightKG ?? ""
      : "",
    "Residue Container Weight (kg)/ಹಿಂಡಿ ಪಾತ್ರೆ ತೂಕ":
      item.cakeOutputs && item.cakeOutputs.length > 0
        ? item.cakeOutputs[0].residueContainerWeightKG ?? ""
        : "",
    "Residue Weight (kg)/ಹಿಂಡಿ ತೂಕ":
      item.cakeOutputs && item.cakeOutputs.length > 0
        ? item.cakeOutputs[0].residueWeightKG ?? ""
        : "",
    "Standard Container and Bottom Maddi Weight (kg)/ಪಾತ್ರೆ ಮತ್ತು ಪಾತ್ರೆ ತಳದಲ್ಲಿನ ಮಡ್ಡಿಯ ತೂಕ (ಕೆಜಿ ಗಳಲ್ಲಿ)":
      item.dailyOutputs && item.dailyOutputs.length > 0
        ? item.dailyOutputs[0].maddiWeightwithContainer ?? ""
        : "",
    "Actual Maddi Weight with Container (kg)/ಮಡ್ಡಿ  ತೂಕ  ಪತ್ರೆ ಸಹಿತ":
      item.dailyOutputs && item.dailyOutputs.length > 0
        ? item.dailyOutputs[0]. containerandBottomMaddiWeight?? ""
        : "",
    "Maddi Weight (kg)/ಮಡ್ಡಿ  ತೂಕ":
      item.dailyOutputs && item.dailyOutputs.length > 0
        ? item.dailyOutputs[0].maddiWeight ?? ""
        : "",
    "Operator 1": item.operator1Name ?? "",
    "Operator 2": item.operator2Name ?? "",

    "Bull 1": item.bull1Name ?? "",
    "Bull 2": item.bull2Name ?? "",
    "Daily Output in litres":
      item.dailyOutputs && item.dailyOutputs.length > 0
        ? item.dailyOutputs[0].dailyOutputLitres ?? ""
        : "",
  "Input to Output Ratio":
  item.dailyOutputs && item.dailyOutputs.length > 0
    ? (item.dailyOutputs[0].inputToOutputRatio !== null &&
       item.dailyOutputs[0].inputToOutputRatio !== undefined)
      ? `${(item.dailyOutputs[0].inputToOutputRatio * 100).toFixed(2)}%`
      : ""
    : "",
             "Vendor": item.vendorName ?? "",

  }));

  // Create a new workbook and worksheet
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(formattedData);

  // Append sheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, "OilProductionLogs");

  // Export as Excel file
  XLSX.writeFile(wb, "OilProductionRecords.xlsx");


};
